import styled, { css } from 'styled-components';
import type { ThemeProps } from 'styled-components';
import type { ThemeType } from '../../util/types';
import { DEFAULT_TRANSITION_FUNC, getPolishedColors } from '../../util/styled';

const ANIMATION_NAME = 'spinner';

const getBordersColor = (props: ThemeProps<ThemeType>) => {
  const colors = getPolishedColors({ theme: props.theme, $color: 'primary' });
  return css`
    border-top: 3px solid ${colors.most_light.color};
    border-right: 3px solid ${colors.most_light.color};
    border-bottom: 3px solid ${colors.most_light.color};
    border-left: 3px solid ${colors.main.color};  
  `;
};

export const LoaderWrapperStyled = styled('div')<{ noMargin?: boolean }>`
  display: flex;
  flex-direction: column;
  ${(props) => !props.noMargin ? 'margin: 1rem;' : ''}
`;

export const LoaderAnimationStyled = styled.div.attrs((props: { smallSize: boolean, noMargin?: boolean }) => ({
  smallSize: props.smallSize,
  noMargin: props.noMargin,
}))`
  position: relative;
  display: flex;
  margin: auto;
  
  width: ${(props) => props.smallSize ? 16 : 30}px;
  height: ${(props) => props.smallSize ? 16 : 30}px;
  background-size: contain;
  ${(props) => props.noMargin ? 'margin-right: 0.5rem;' : ''}
  
  &:after {
    content: '';
    display: flex;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    ${(props) => getBordersColor(props)}
    
    animation: ${ANIMATION_NAME} ${DEFAULT_TRANSITION_FUNC} 1s infinite;
    
    @keyframes ${ANIMATION_NAME} {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(1turn);
      }
    }
  }
`;
